import moment from 'moment';
import { validateEmail, validatePoBoxAddress } from 'utils/helper';
import { numberUnmask } from 'utils/unmasks';
import get from 'lodash/get';
import { unsupportedStates, unsupportedStatesDPOnly } from 'utils/unsupportedStates';

export default {
  annualGrossIncome: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  email: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        const blokingEmails = [
          'none@none.com',
          'noemail@noemail.com',
          'noemail@gmail.com',
          'noemail@email.com',
          'none@noemail.COM',
          'none@gmail.com',
          'none@yahoo.com',
          'no@no.com',
          'no@email.com',
          'noemail@yahoo.com',
          'test@test.com',
          'na@na.com',
          'noname@gmail.com',
          'no@gmail.com',
          'noemail@mail.com',
          'test@email.com',
          'unknown@yahoo.com',
          'non@non.com',
          'noemal@noemail.com',
          'none@email.com',
          'noname@email.com',
          'noemail@no.com',
          'non@none.com',
          'email@email.com',
          'nomail@gmail.com',
          'noemail@gimail.com',
          'noemail@aol.com',
          'na@gmail.com',
          'noemail@gmai.com',
          'noemail@noemai.com',
          'none@aol.com',
          'na@na.com',
          'noemail@aol.com',
        ];

        return (
          (blokingEmails.indexOf(`${input}`.toLowerCase()) !== -1)
          || !validateEmail(input)
        ) ? 'Email is not valid' : true;
      },
    },
  ],
  firstName: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  lastName: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  mobilePhoneNumber: [{
    rule: 'required',
    isValid: (input) => !!input || 'The input field is required',
  }],
  employmentStatus: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  employmentYears: [{
    isValid: (input, err, opt, formData) => {
      const employmentStatus = get(formData, 'employmentStatus');
      if (employmentStatus === 'retired' || employmentStatus === 'unemployed' || employmentStatus === 'student') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }
    },
  }],
  ssn: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!input) {
        return 'The input field is required';
      }

      switch (formData.hasSsn) {
        case true:
          if (numberUnmask(input).length < 4) {
            return 'SSN is not valid';
          }
          break;
        default: {
          const blockingSsns = [
            '078-05-1120',
            '219-09-9999',
            '111-11-1111',
            '222-22-2222',
            '333-33-3333',
            '444-44-4444',
            '555-55-5555',
            '666-66-6666',
            '777-77-7777',
            '888-88-8888',
            '999-99-9999',
            '123-45-6789',
          ];

          if (
            (!formData.hasSSN && numberUnmask(input).length < 9)
            || numberUnmask(input).substring(0, 3) === '000'
            || numberUnmask(input).substring(3, 5) === '00'
            || numberUnmask(input).substring(5, 9) === '0000'
            || (Number(numberUnmask(input).substring(0, 3)) > 899 && Number(numberUnmask(input).substring(0, 3)) < 1000)
            || blockingSsns.includes(input)
          ) {
            return 'SSN is not valid';
          }
        }
      }
      return true;
    },
  }],
  address: [{
    rule: 'required',
    isValid: (input) => {
      if (!`${input}`.trim()) {
        return 'The input field is required';
      }

      return validatePoBoxAddress(`${input}`.trim() || '')
        ? 'Address is not valid'
        : true;
    },
  }],
  city: [{
    rule: 'required',
    isValid: (input) => !!`${input}`.trim() || 'The input field is required',
  }],
  state: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!input) {
        return 'The input field is required';
      }

      if (formData && formData.workflowType === 'text2apply-dponly') {
        return (
          unsupportedStatesDPOnly.indexOf(input) !== -1
        ) ? 'We are not supporting this state.' : true;
      }

      return (
        unsupportedStates.indexOf(input) !== -1
      ) ? 'We are not supporting this state.' : true;
    },
  }],
  zip: [{
    rule: 'required',
    isValid: (input) => {
      const blockedZipcode = [
        '00000',
        '11111',
        '22222',
        '33333',
        '44444',
        '55555',
        '66666',
        '77777',
        '88888',
        '99999',
      ];

      if (!input) {
        return 'The input field is required';
      }
      return (input.replace('_', '').length !== 5 || blockedZipcode.indexOf(input || '') !== -1) ? 'Zipcode is not valid' : true;
    },
  }],
  dateOfBirth: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        if (numberUnmask(input).length < 8) {
          return 'Date of Birth is not valid';
        }

        if (!moment(input, 'MM/DD/YYYY').isValid()) {
          return 'Date of Birth is not valid';
        }

        if (moment.duration(moment(new Date()).diff(moment(input, 'MM-DD-YYYY'))).asYears() < 18) {
          return 'Must be over 18 years old';
        }

        if (parseInt(input.slice(-4), 10) < 1900) {
          return 'Please confirm date of birth';
        }
        return true;
      },
    },
  ],
  agreeTerms: [{
    rule: 'required',
    isValid: (input) => input || 'You must accept the terms',
  }],
};
